import { matchPath, useLocation } from "react-router-dom/cjs/react-router-dom.min"

export const useCurrentPageMatch = () => {
  const location = useLocation();

  const isCurrentPageMatch = (route, options = {}) => {
    const {exact = true, strict = false} = options;

    return !!matchPath(location.pathname, {
    path: route,
    exact,
    strict
  })}

  return { isCurrentPageMatch }
}